// Gerado por `pnpm modules:sync` a partir dos module.json (ADR 0123). Não edite à mão.
import type { WebModule } from './web-module.ts';
import { webModule as customers } from './customers/module.tsx';
import customersEn from './customers/i18n/en.json';
import customersPtBR from './customers/i18n/pt-BR.json';

export const WEB_MODULES: readonly WebModule[] = [
  customers,
];

/** Os textos de cada módulo, debaixo da chave com o id dele (`t('<id>.…')`). */
export const MODULE_TRANSLATIONS = {
  'pt-BR': {
    customers: customersPtBR,
  },
  en: {
    customers: customersEn,
  },
};
